import React, {useState, useEffect} from "react";
import styles from "./OTPTimer.module.css";

const OTPTimer = ({duration = 120, onResend}) => {
    const [timeLeft, setTimeLeft] = useState(duration);
    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        if (timeLeft <= 0) {
            setIsDisabled(false);
            return;
        }

        // Store the end time instead of counting down
        const endTime = Date.now() + timeLeft * 1000;

        const timer = setInterval(() => {
            const remainingTime = Math.max(0, Math.round((endTime - Date.now()) / 1000));
            setTimeLeft(remainingTime);

            if (remainingTime <= 0) {
                clearInterval(timer);
                setIsDisabled(false);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [duration, onResend]); // Only re-run when duration or onResend changes

    const handleResend = () => {
        setTimeLeft(duration);
        setIsDisabled(true);
        onResend();
    };

    // Format time as MM:SS
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    const formattedTime = `${minutes}:${seconds.toString().padStart(2, "0")}`;

    return (
        <div className={styles.timerContainer}>
            {isDisabled ? (
                <p className={styles.timerText}>
                    اگر کدی دریافت نکردید، <strong>
                    {minutes > 0 ? `${minutes} دقیقه و ` : ""}
                    {seconds} ثانیه</strong> صبر کنید، سپس می‌توانید درخواست کد جدید بدهید.
                </p>
            ) : (
                <p className={styles.resendText} onClick={handleResend}>
                    کد را دریافت نکردید؟ <span className={styles.resendLink}>ارسال مجدد کد</span>
                </p>
            )}
        </div>
    );
};

export default OTPTimer;